import axios from "axios";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY

export const LOGIN_URL = "api/auth/login";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";

export function login(email, password) {

  let data = {
    userPassword: password,
    userEmail: email
  }
  data = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString()
  data = JSON.stringify({ data: data })
  return axios.post(process.env.REACT_APP_NODE_ENV + '/api/users/getUserByLogin', data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
    }
  });
}

export function wordpressLogin(token) {
  let data = JSON.stringify({
    userToken: token
  })
  return axios.post(process.env.REACT_APP_NODE_ENV + '/api/users/getUserDatabyToken', data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
    }
  });
}

export function requestPassword(email) {
  return axios.get(process.env.REACT_APP_NODE_ENV + '/api/users/getUserByEmail/' + email, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
    }
  });
}